import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ActivationGuard } from './core/guards/activation-guard.guard';
import { DoLogoutGuard } from './core/guards/do-logout.guard';
import { LayoutComponent } from './shared/pages/layout/layout.component';
import { AuthGuardService } from './core/services/auth-guard.service';
import { environment } from '../environments/environment';
import { NotFoundComponent } from './shared/pages/not-found/not-found.component';
import { WorkInProgressComponent } from './shared/pages/work-in-progress/work-in-progress.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [ActivationGuard],
    pathMatch: 'full',
    children: [],
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'registration',
    component: LayoutComponent,
    loadChildren: () => import('./modules/registration/registration.module').then((m) => m.RegistrationModule),
    canLoad: [DoLogoutGuard],
  },
  {
    path: 'questionnaire/:childUuid',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./modules/questionnaire/questionnaire.module').then((m) => m.QuestionnaireModule),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'user',
        loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'result',
        loadChildren: () => import('./modules/result/result.module').then((m) => m.ResultModule),
      },
      {
        path: 'info',
        loadChildren: () => import('./modules/info/info.module').then((m) => m.InfoModule),
      },
      {
        path: 'portfolio',
        loadChildren: () => import('./modules/portfolio/portfolio.module').then((m) => m.PortfolioModule),
      },
      {
        path: 'plan',
        loadChildren: () => import('./modules/plan/plan.module').then((m) => m.PlanModule),
      },
      {
        path: 'recommendations',
        loadChildren: () => import('./modules/recommendations/recommendations.module').then((m) => m.RecommendationsModule),
      },
    ],
  },
  {
    path: 'maintenance',
    component: WorkInProgressComponent,
    pathMatch: 'full',
  },
  { path: '**', component: NotFoundComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: !environment.production && false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 75],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
